import axios, { AxiosError, AxiosInstance } from "axios";
import { ApiNetworkErrorSentinel } from "./api-results/types";

// Bare client for third-party APIs: no auth header, no session interceptors.
// Requests opt in with `isPublic: true` on the query object.
const publicAxios = axios.create({ withCredentials: false });

// TODO: type
// oxlint-disable-next-line typescript/no-explicit-any
type BaseQueryParams = any;

export const baseQuery =
  (axiosInstance: AxiosInstance) => async (params: BaseQueryParams) => {
    const client = params?.isPublic ? publicAxios : axiosInstance;

    try {
      const response = await client(params);

      return {
        data: params?.rawResponse
          ? {
              data: response.data,
              headers: response.headers,
              status: response.status,
              statusText: response.statusText,
            }
          : response.data,
      };
    } catch (error: unknown) {
      const axiosError = error as AxiosError & { _isSimulated?: boolean };
      // The config reference is shared with the AxiosError so handled-error
      // tracking can correlate this sentinel with the error seen by interceptors.
      const networkErrorSentinel: ApiNetworkErrorSentinel = {
        __NETWORK_ERROR: true,
        config: axiosError.config,
        code: axiosError.code,
        _isSimulated: axiosError._isSimulated,
      };
      return {
        error: axiosError.response || networkErrorSentinel,
      };
    }
  };
